

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = function( root, jQuery ) {
            if ( jQuery === undefined ) {
                if ( typeof window !== 'undefined' ) {
                    jQuery = require('jquery');
                }
                else {
                    jQuery = require('jquery')(root);
                }
            }
            factory(jQuery);
            return jQuery;
        };
    } else {
        factory(jQuery);
    }
}(function ($) {
	'use strict'; 

		var pluginName				= 'valForm';

		var defaults = {
		callback				: null,
		showError				: true,
		debug					: true,
		scrollError				: true
	};

		var elements				= {
		formElmt				: ['input','textarea','select'],
		inputType				: ['checkbox','text','password','radio','hidden']
	};


		function findFormType($elmt) {
		var sType				= false;

						var tagName				= $elmt.prop('tagName');
		var tagNameSafe			= tagName ? tagName.toLowerCase() : null;

		if(elements.formElmt.indexOf(tagNameSafe) >= 0){
			if(tagNameSafe === 'input'){
				var attr		= $elmt.attr('type');
				if(elements.inputType.indexOf(attr) >= 0){
					sType		= attr;
				}
				else{
					sType		= 'text';
				}
			}
			else{
				sType			= tagNameSafe;
			}
		}

						return sType;
	}


		var valForm					= function (form, fields, options) {
		this.form				= $(form);
		this.fields				= fields;
		this.settings			= $.extend({}, defaults, options);
		this.frmVal				= true;
		this.checkFields		= {};

				this._init();
	};

	valForm.prototype			= {
		_init: function () {
			var self			= this;

						var nbFields		= 0;

						if($.isArray(self.fields) && self.fields.length > 0) {
				$.each(self.fields, function() {
					var sKey			= null;

					if(typeof(this.id) !== 'undefined') {
						this.elmt		= $('#'+this.id);
						sKey			= this.id;
					}
					else if(typeof(this.selector) !== 'undefined') {
						this.elmt		= self.form.find(':input[name="'+this.selector+'"]');
						sKey			= this.name;
					}
					else if(typeof(this.name) !== 'undefined') {
						this.elmt		= self.form.find(':input[name="'+this.name+'"]');
						sKey			= this.name;
					}

										if(sKey === null) {
						if(self.settings.debug) {
							alert(sKey + ' Not defined...');
						}
						return true;
					}

					this.type			= findFormType(this.elmt);

										if(!this.type) {
						if(self.settings.debug) {
							alert(sKey + ' Not reconized... remove this check entrance');
						}
					}
					else {
						this.contenair 	= $(this.elmt).closest('.form-valid');
						this.error 		= false;
						if((this.type === 'text' || this.type === 'password') && typeof(this.relto) !== 'undefined') { 
							this.reg 	= undefined;
						}

						if($(this.contenair).hasClass('has-error')) { 
							self._setError(this);
						}
						self.checkFields[sKey] = this;
						nbFields++;
					}
				});
			}

						if(nbFields) {
				self.form.on('submit', function(event) {

					self.frmVal			= true;
					var bmove			= null;

					$.each(self.checkFields, function() {
						self._verifVal(this);

						if(self.settings.scrollError && !self.frmVal && bmove === null) {
							bmove		= true;

							var pos		= $(this.elmt).offset();
							$('html, body').animate({scrollTop:pos.top - 110}, 'fast');
						}
					});

					if (self.settings.callback !== null && $.isFunction(self.settings.callback)) {
						event.preventDefault();
						self.settings.callback(self.frmVal, self.form);
					}
					else {
						return self.frmVal;
					}
				});
			}
			else if(self.settings.debug) {
				alert('No field to check - Disable valForm');
			}
		},
		_bindEvent : function (field) {

							var self			= this;
			var eventName;

						switch(field.type) {
				case 'text' :
				case 'password' :
				case 'textarea' :
					eventName	= 'input.err';
					break;
				case 'checkbox' :
				case 'radio' :
				case 'hidden' :
				case 'select' :
					eventName	= 'change.err';
					break;
			}

							if(eventName) {
				$(field.elmt).on(eventName, function () {
					self._verifVal(field);
				});
			}
		},
		_verifVal : function(field) {

							var self			= this;
			if (typeof(field.checkMethod) !== 'undefined' && $.isFunction(field.checkMethod)) {
				var bVal		= field.checkMethod(field);

				if(!bVal) {
					self._setError(field);
				}
				else if(field.error) {
					self._clearError(field);
				}
			}
			else {
				switch(field.type) {
					case "text" :
					case "password" :
					case "textarea" :
					case "hidden" :
						var sVal 	= $.trim($(field.elmt).val());

						var bError 	= false;

						if(typeof(field.reg) !== "undefined") {
							var expreg = new RegExp(field.reg, 'i');
							if (expreg.exec(sVal) === null) {
								bError = true;
							}
						}
						else if (typeof(field.relto) !== "undefined") {
							if(sVal !== $(field.relto).val()) {
								bError = true;
							}
						}
						else if(sVal === "") {
							bError = true;
						}

						if(bError) {
							self._setError(field);
						}
						else if(field.error) {
							self._clearError(field);
						}
						break;
					case "checkbox" :
					case "radio" :
						var n = $(field.elmt).filter("input:checked").length;
						if (n === 0) {
							self._setError(field);
						}
						else if(field.error) {
							self._clearError(field);
						}
						break;
					case "select" :
						if ($(field.elmt).val() === null || $(field.elmt).val() === "" || $(field.elmt).val() === "0" || $(field.elmt).val() === 0) { 
							self._setError(field);
						}
						else if(field.error) {
							self._clearError(field);
						}
						break;
				}
			}
		},
		_setError : function(field, message) {
			var self			= this;
			self.frmVal			= false;
			var $cont			= $(field.contenair);
			var mess			= message || field.mess;

						if(self.settings.showError && !$cont.find('span.control-error').length) {
				$cont.append("<span class='control-error'>"+mess+"</span>");
			}

			$cont.addClass('has-error');

			if(!field.error) {
				self._bindEvent(field);
			}

			field.error			= true;
		},
		_clearError : function(field) {
			var self			= this;
			if(field.error) {
				if(self.settings.showError) {
					$(field.contenair).find('span.control-error').remove();
				}
				$(field.contenair).removeClass('has-error');
				$(field.elmt).off('.err');
				field.error		= false;
			}
			$(field.contenair);
		},
		setErrors : function(errors) {
			var self			= this;
			if(!$.isEmptyObject(errors)) {

								$.each(self.checkFields, function() {
					var error	= errors[this.elmt.attr('name')] || null;

										if($.isArray(error) && error.length > 0) {
						self._setError(this, error[0]);
					}
				});
			}
		}
	};

		$.fn[pluginName] = function( fields, options ) {
		return this.each( function() {
			if (!$.data(this, 'plugin_' + pluginName ) ) {
				$.data( this, 'plugin_' +
					pluginName, new valForm( this, fields, options ) );
			}
		});
	};
}));